import React from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Problem } from './components/Problem';
import { WhatYouGet } from './components/WhatYouGet';
import { Gallery } from './components/Gallery';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showUrgency?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showUrgency = true,
  showPurchaseNotifications = true
}: AppProps) {
  useMetaPixel();
  return <div className="w-full bg-white" data-id="element-0" data-mp="23vkuoemiy5k6">
      <main data-id="element-1" data-mp="23ujlygszdv5m">
        <Hero data-id="element-2" data-mp="23v2rey1g2r2r" />
        <ProofBar data-id="element-3" data-mp="23t8h0dnsuhcx" />
        <Problem data-id="element-4" data-mp="3ijxsgzk2wgo4" />
        <Gallery data-id="element-5" data-mp="3ikh5c1uvgeva" />
        <WhatYouGet data-id="element-6" data-mp="3iiwaeb4natww" />
        <Comparison data-id="element-7" data-mp="3ijpbavgxap74" />
        <Bonuses data-id="element-8" data-mp="3ii4ro0w5cqo1" />
        <Pricing showUrgency={showUrgency} data-id="element-9" data-mp="3mlaxx8j9ehui" />
        <Guarantee data-id="element-10" data-mp="3mjzsz5e2v41t" />
        <Faq data-id="element-11" data-mp="3mjgannkimdn9" />
        <FinalCta data-id="element-12" data-mp="3mj6lg27aoaim" />
      </main>
      <Footer data-id="element-13" data-mp="3rbzmog3k10py" />
      {showPurchaseNotifications && <PurchaseToast data-id="element-14" data-mp="3rd189ei755lx" />}
    </div>;
}